import React from 'react';
import styled, { css } from 'styled-components';
import { spin, insideLoader1, insideLoader2 } from 'styles';

export function Loading({ type }) {
  const onClickHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <CustomLoading onClick={onClickHandler} type={type}>
      <div className="loader" />
    </CustomLoading>
  );
}

const CustomLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ type }) =>
    (type === 'inside' &&
      css`
        position: absolute;
        top: 50%;
        left: 50%;
        & > .loader {
          position: relative;
          width: 10px;
          height: 10px;
          top: 0;
          left: 0;
          border-radius: 10px;
          background-color: ${({ theme }) => theme.colors.primary};
        }
        & > .loader::before {
          content: '';
          position: absolute;
          top: 0px;
          height: 10px;
          width: 10px;
          border-radius: 10px;
          -webkit-animation: ${insideLoader1} 3s ease-in-out infinite;
          animation: ${insideLoader1} 3s ease-in-out infinite;
        }
        & > .loader::after {
          content: '';
          position: absolute;
          top: 0px;
          height: 10px;
          width: 10px;
          border-radius: 10px;
          -webkit-animation: ${insideLoader2} 3s ease-in-out infinite;
          animation: ${insideLoader2} 3s ease-in-out infinite;
        }
      `) ||
    (type !== 'inside' &&
      css`
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0;
        & > .loader {
          position: relative;
          width: 40px;
          height: 40px;
          border-radius: 100%;
          border: 3px solid rgba(163, 163, 163, 0.2);
          border-right: 3px solid ${({ theme }) => theme.colors.primary};
          border-top: 3px solid ${({ theme }) => theme.colors.primary};
          animation: ${spin} 1s linear infinite;
        }
      `)}
`;
